export type BillingPlan = "monthly" | "annual";

const SUBSCRIPTION_PLAN_STORAGE_KEY = "subscriptionPlan";
const PENDING_SUBSCRIPTION_PLAN_STORAGE_KEY = "pendingSubscriptionPlan";

export const isBillingPlan = (
  value: string | null | undefined
): value is BillingPlan => value === "monthly" || value === "annual";

export const getSubscriptionPlanFromSearch = (
  search: string
): BillingPlan | null => {
  const params = new URLSearchParams(search);
  const plan = params.get("plan");

  return isBillingPlan(plan) ? plan : null;
};

export const getStoredSubscriptionPlan = (): BillingPlan | null => {
  if (typeof window === "undefined") {
    return null;
  }

  const plan = window.localStorage.getItem(SUBSCRIPTION_PLAN_STORAGE_KEY);
  return isBillingPlan(plan) ? plan : null;
};

export const setStoredSubscriptionPlan = (plan: BillingPlan) => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(SUBSCRIPTION_PLAN_STORAGE_KEY, plan);
};

export const savePendingSubscriptionPlan = (plan: BillingPlan) => {
  if (typeof window === "undefined") {
    return;
  }

  setStoredSubscriptionPlan(plan);
  window.localStorage.setItem(PENDING_SUBSCRIPTION_PLAN_STORAGE_KEY, plan);
};

export const consumePendingSubscriptionPlan = (): BillingPlan | null => {
  if (typeof window === "undefined") {
    return null;
  }

  const plan = window.localStorage.getItem(
    PENDING_SUBSCRIPTION_PLAN_STORAGE_KEY
  );

  window.localStorage.removeItem(PENDING_SUBSCRIPTION_PLAN_STORAGE_KEY);

  return isBillingPlan(plan) ? plan : null;
};
